import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=b87a369c&scoped=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"
import style0 from "./Error.vue?vue&type=style&index=0&id=b87a369c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a369c",
  null
  
)

export default component.exports